import { Sheet, SheetContent, SheetHeader, SheetTitle, SheetFooter } from '@/components/ui/sheet';
import { Button } from '@/components/ui/button';
import { SubmitButton } from '@/components/ui/app/submit-button';
import { useTheme } from '@/lib/contexts/theme-context';
import FormReportFinalize, { FORM_REPORT_FINALIZE_ID } from '../forms/FormReportFinalize';
import { useTranslation } from 'react-i18next';

/**
 * Sheet pour finaliser un brouillon de rapport de procédure
 * Affiche le récapitulatif des jetons, le dossier de destination et un avertissement
 */
export default function SheetReportFinalize({
    open,
    onClose,
    onFinalize,
    onSaveDraft,
    isFinalizing = false,
    tokenCostPdf = 2,
    folderName = '',
}) {
    const { t } = useTranslation();
    const { theme } = useTheme();
    const isHorodateme = theme.slug === 'horodateme';
    const totalTokens = tokenCostPdf;

    return (
        <Sheet open={open} onOpenChange={(isOpen) => !isOpen && onClose()}>
            <SheetContent className="w-[90vw] md:w-[480px]! md:max-w-[480px]! flex flex-col p-0">
                <SheetHeader className="px-5 py-4 border-b border-border">
                    <SheetTitle className="text-lg font-semibold text-foreground">{t('procedures:finaliserLeRapport')}</SheetTitle>
                </SheetHeader>

                <FormReportFinalize onSubmit={onFinalize} tokenCostPdf={tokenCostPdf} folderName={folderName} />

                <SheetFooter className="px-5 py-4 border-t border-border flex-row gap-3">
                    {onSaveDraft && (
                        <Button
                            type="button"
                            variant="soft"
                            color="neutral"
                            size="xxl"
                            onClick={onSaveDraft}
                            disabled={isFinalizing}
                            className="flex-1 rounded-xl text-surface-foreground"
                        >
                            {t('procedures:enregistrerLeBrouillon')}
                        </Button>
                    )}
                    <SubmitButton
                        form={FORM_REPORT_FINALIZE_ID}
                        size="xxl"
                        isSubmitting={isFinalizing}
                        loadingText={t('procedures:finalisation')}
                        className="flex-1 rounded-xl flex-col items-center"
                    >
                        <span className="text-[15px]">{t('procedures:finaliserLeRapport')}</span>
                        {!isHorodateme && (
                            <span className="text-xs opacity-70">
                                -{totalTokens} jeton{totalTokens > 1 ? 's' : ''}
                            </span>
                        )}
                    </SubmitButton>
                </SheetFooter>
            </SheetContent>
        </Sheet>
    );
}
